<template>
  <ul class="component-tag__list" v-if="tagLinks || tagStrings[0]">
    <template v-if="tagLinks">
      <c-component-link
        class="component-tag__item"
        v-for="(tag, index) in tagLinks"
        :key="index"
        data-test-tag
        @click.capture="onTagClick($event, tag)"
        :url="tag.link"
      >
        {{ tag.label }}
      </c-component-link>
    </template>
    <template v-else>
      <li
        class="component-tag__item"
        v-for="(tag, index) in tagStrings"
        :key="index"
        data-test-tag
        @click="onTagClick($event, tag)"
      >
        {{ tag }}
      </li>
    </template>
  </ul>
  <ul v-else-if="useSpacer" class="component-tag__list">
    <li class="component-tag__item component-tag__item--spacer"></li>
  </ul>
</template>

<script>
import { computed, defineComponent, toRefs } from 'vue'
import CComponentLink from '../../components/CComponentLink/CComponentLink.vue'

const TAG_SEPARATOR = ';'

export default defineComponent({
  name: 'PComponentTag',
  components: {
    CComponentLink,
  },
  props: {
    separator: { default: TAG_SEPARATOR, type: String },
    tag: { default: '', type: String },
    tagLinks: {
      default: null,
      type: Array,
    },
    useSpacer: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { emit }) {
    const { tag, separator } = toRefs(props)
    const tagStrings = computed(() => tag.value.split(separator.value).filter(Boolean))
    const onTagClick = (_, tagName) => {
      emit('component-tag-click', tagName)
    }
    return {
      tagStrings,
      onTagClick,
    }
  },
})
</script>

<style lang="scss" scoped>
.component-tag__list {
  display: flex;
  gap: var(--tagsGap, var(--spacing-2, 0.8rem)) !important;
  padding: var(--article-tags-padding, 0 0 0 0) !important;
  flex-wrap: wrap;

  .component-tag__item,
  .component-tag__item--spacer::after {
    display: inline-block;
    font-size: var(--tagFontSize, var(--font-size-xs, 1.2rem)) !important;
    line-height: var(--tagLineHeight, var(--line-height-xs, 2rem)) !important;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 4%;
    padding: var(--tagPadding, var(--spacing-1, 0.4rem)) !important;
    border-radius: var(--tagBorderRadius, var(--border-radius-2, 0.8rem)) !important;
    color: var(--tagTextColor, var(--color-text, #141414)) !important;
    background-color: var(--tagBackgroundColor, var(--color-success-background, #e0ffb9)) !important;
    margin: var(--tagMargin, 0 0 var(--spacing-2, 0.8rem) 0) !important;
  }

  .component-tag__item--spacer {
    background-color: transparent;

    &::after {
      content: '';
    }
  }
}
</style>
